import { useNavigate } from 'react-router-dom';

import { ObjectKeys } from 'types/common';

import { USER_TYPE_REDIRECTS } from 'features/user/config';

export const useUserTypeDefaultNavigate = () => {
  const navigate = useNavigate();

  return (userType: ObjectKeys<typeof USER_TYPE_REDIRECTS>) => {
    navigate(`${USER_TYPE_REDIRECTS[userType]()}`);
  };
};
